export const REPORTS_TEXT = Object.freeze({
  sales: {
    page: {
      defaultHeaderTitle: 'Reportes',
      defaultHeaderSubtitle: 'Análisis de ingresos, facturación, notas simples y rentabilidad.',
      tabHeaderPrefix: 'Reportes de',
      headerActions: {
        excel: 'Excel',
        pdf: 'PDF',
      },
      exportFileSegments: {
        sales_done: 'negocios_realizados',
        sales_invoiced: 'negocios_facturados',
        sales_simple_notes: 'negocios_notas_simples',
        sales_profitability: 'rentabilidad_negocios',
        default: 'reporte_ventas',
      },
      toasts: {
        exportUnavailable: 'La exportación para este reporte aún no está disponible.',
        excelSuccess: 'Reporte descargado en Excel.',
        pdfSuccess: 'Reporte descargado en PDF.',
        excelError: 'No fue posible descargar el reporte en Excel.',
        pdfError: 'No fue posible descargar el reporte en PDF.',
      },
    },
    tabs: {
      profitability: {
        key: 'sales_profitability',
        label: 'Rentabilidad de Negocios',
        headerTitle: 'Reportes de Rentabilidad de Negocios',
        description: 'Análisis real de utilidad y margen por negocio y responsables.',
      },
    },
    chart: {
      variants: [
        { value: 'income_vs_expenses', label: 'Ingresos vs gastos' },
        { value: 'budget_vs_expenses', label: 'Presupuesto vs Gastos' },
        { value: 'utility', label: 'Utilidad' },
      ],
    },
    chartSection: {
      title: 'Tendencia del reporte',
      subtitle: 'Comparativo del periodo seleccionado.',
      modeAriaLabel: 'Tipo de gráfica',
      variantAriaLabel: 'Métrica de rentabilidad',
      visibilityAriaLabel: 'Visibilidad de gráfica',
      defaultSeriesName: 'Monto',
      hideChartButton: 'Ocultar',
      showChartButton: 'Mostrar',
      hiddenState: 'La gráfica esta oculta en esta sesion.',
      modeButtons: {
        bar: 'Barras',
        line: 'Lineal',
        points: 'Puntos',
      },
    },
    detail: {
      loadingSubtitle: 'Cargando información...',
      loadErrorSubtitle: 'No fue posible cargar el detalle.',
      titlePrefix: 'Detalle de',
      defaultReportLabel: 'reporte',
      recordLabelSingular: 'registro',
      recordLabelPlural: 'registros',
    },
    detailModal: {
      defaultTitle: 'Detalle del periodo',
      closeAriaLabel: 'Cerrar modal',
      loadingState: 'Cargando detalle...',
      emptyState: 'No hay detalle disponible para esta selección.',
      grandTotalLabel: 'Total',
      closeButton: 'Cerrar',
      columnFallbackPrefix: 'Columna',
      emptyValueDash: '-',
    },
    filterToolbar: {
      ariaLabel: 'Filtros del reporte',
      noOptions: 'Sin opciones',
      toggleHideTitle: 'Ocultar filtros',
      toggleShowTitle: 'Mostrar filtros',
      applyTitle: 'Aplicar filtros',
      sort: {
        buttonPrefix: 'Orden',
        options: {
          none: 'Sin ordenamiento',
          asc: 'Ascendente',
          desc: 'Descendente',
        },
      },
      dateRangePresets: [
        { key: 'this_month', label: 'Este mes' },
        { key: 'last_month', label: 'Mes anterior' },
        { key: 'this_year', label: 'Año actual' },
        { key: 'to_date', label: 'Al día de hoy' },
        { key: 'last_year', label: 'Año anterior' },
      ],
      allLabel: 'Todos',
      selectedLabelSuffix: 'seleccionados',
      columnSingular: 'Columna',
      columnPlural: 'Columnas',
      defaultPrefix: 'Filtro',
    },
    profitability: {
      kpis: {
        businessesTitle: 'Negocios',
        incomesTitle: 'Ingresos totales',
        expensesTitle: 'Gastos Total',
        budgetTitle: 'Presupuesto total',
        utilityTitle: 'Utilidad',
        businessesSuffix: 'negocios',
        incomesCollectedPrefix: 'Cobrado:',
        expensesPaidPrefix: 'Pagado:',
        budgetProgressLabel: 'Progreso de gastos',
        totalForecastLabel: 'Total pronóstico:',
        totalLabel: 'Total:',
        paidLabel: 'Pagado:',
        marginForecastLabel: 'Margen:',
        marginLabel: 'MARGEN',
        utilityRealLabel: 'Utilidad real:',
        marginRealLabel: 'Margen real:',
      },
      table: {
        captionPrefix: 'Vista',
        captionGroupedBy: 'agrupada por',
        totalGeneral: 'Total general',
        headers: {
          amount: 'Importe',
          incomeProgress: 'Progreso de ingresos',
          budgets: 'Presupuestos',
          expensesProgress: 'Progreso de gastos',
          utility: 'Utilidad',
          total: 'Total',
          percent: '%',
          paid: 'Pagado',
          expenses: 'Gastos',
          fees: 'Comisiones',
          totalExpenses: 'Total gastos',
          real: 'Real',
        },
        pivots: {
          cliente: 'Cliente',
          responsable: 'Responsable',
          vendedor: 'Vendedor',
          servicio: 'Servicio',
          negocio: 'Negocio',
          cliente_negocio: 'Cliente negocio',
          responsable_negocio: 'Responsable negocio',
          vendedor_negocio: 'Vendedor negocio',
          servicio_negocio: 'Servicio negocio',
          defaultColumn: 'Columna',
          unknownBusiness: 'Sin negocio',
          emptyCell: '-',
        },
        views: {
          subtotal: 'Subtotal',
          total: 'Total',
        },
      },
    },
  },
});
